export default "__VITE_ASSET__sPGI2Z$y__"